import {EQDepartment} from "../EQDepartment";

export interface EDTutor {
  // DBField
  uid: number;
  companyUID: number;
  departmentUID: number;
  name: string; // 강사명
  carreer: string; // 경력사항
  qualification: string; // 자격현황
  internalEducation: string; // 내부교육이수현황
  externalEducation1: string; // 외부교육이수현황1
  externalEducation2: string; // 외부교육이수현황1
  certificationFile: string; // 수료증 파일
  note: string; // 비고
  isDeleted: boolean; // 삭제여부

  // Non DB
  department: EQDepartment;
  base64: string; // 수료증 파일의 base64값
}

export interface TutorListParams {
  page: number;
  token: string;
  rows?: number; // 표시 행 수
  filterSearchWord: string; // 이름
  filterCareer: string; // 경력사항
  filterQualification: string; // 자격현황
  filterExternalEducation: string; // 외부교육현황
}

export const initialTutorListParams = {
  page: 1,
  token: "",
  rows: 20, // 표시 행 수
  filterSearchWord: "", // 이름
  filterCareer: "", // 경력사항
  filterQualification: "", // 자격현황
  filterExternalEducation: "", // 외부교육현황
};

export const initializeTutor = {
  uid: 0,
  companyUID: 0,
  departmentUID: 0,
  name: "",
  carreer: "",
  qualification: "",
  internalEducation: "",
  externalEducation1: "",
  externalEducation2: "",
  certificationFile: "",
  note: "",
  isDeleted: false,
};
